<template>
    <div class="notice">
        <div class="notice-container">
            <h3>{{ noticeTitle }}</h3>
            <div v-html="noticeContent" class="notice-info"></div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { postNoticeInfo } from "@/api";
import { useRoute } from 'vue-router';
const route = useRoute();
const noticeId = ref<number>(21668);
const noticeTitle = ref<string>('');
const noticeContent = ref<string>('');

// 获取公告详情
const getNoticeInfo = async  () => {
    const params = {
        id: route.params.id || noticeId.value
    }
    const result =  await postNoticeInfo(params);
    if (result.data?.data) {
        const data = result.data?.data.noticeInfo;
        noticeTitle.value = data.title;
        noticeContent.value = data.content;
    }
}

getNoticeInfo();


</script>

<style lang="scss">
.notice {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
    h3 {
        font-size: 24px;
        font-weight: 500;
        margin-bottom: 40px;
    }
    .notice-container {
        width: 1200px;
        background-color: #fff;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        border-radius: 10px;
        padding: 25px;
    }
    .notice-info {
        font-size: 14px;
        a {
            color: #19bca0;
        }
        h2 {
            font-size: 20px;
            margin-bottom: 10px;
        }
        p {
            margin-bottom: 15px;
        }
    }

}

@media (max-width: 1200px) {
    .notice {
        padding: 15px;
        .notice-container {
            width: 100%;
        }
        .notice-content {
            margin-left: 0px;
            margin-top: 15px;

            .notice-info {
                img {
                    width: 100%;
                }
            }
        }

    }
}
</style>